import Service from "@/services/billing";
//import {router} from '@/plugins/router'

export default {
  namespaced: false,
  state: {
    list: {},
  },
  actions: {
    getBilling({ dispatch, commit }, id) {
      Service.get(id)
        .then((data) => {
          commit("billing", { data: data.data, id: id });
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    resetBilling({ commit }) {
      commit("resetbilling");
    },
  },
  mutations: {
    billing(state, payload) {
      if (Array.isArray(payload.data) && payload.data.length !== 0) {
        state.list[payload.id] = payload.data;
      } else {
        delete state.list[payload.id];
      }
      state.list = JSON.parse(JSON.stringify(state.list));
    },
    resetbilling(state) {
      state.list = {};
    },
  },
};
